<template>
  <div id="contendor-principal-anexo" class="area col-12">
      <div id="contenedor-encabezados-envioDeCedulas" class="text-center">
          <h1>VISTA GENERAL DEL REPORTE </h1>
          <hr />
          <div class="contenedor-color-negro d-flex justify-content-between align-items-center">
            <div>
              <button type="button" @click="regresarVistaAnterior" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left"></i></button>
            </div>
            <div class="d-flex align-items-center">
              <h3>Reporte generado en la fecha:</h3>
              <div id="fecha-busqueda-informacion" class="d-flex justify-content-center align-items-center p-3 ml-2">
                  <h4><i class="fas fa-calendar-day"></i>&nbsp;&nbsp;{{fechaDeReporte}}</h4>
              </div>
            </div>
          </div>
      </div>
      <div class="mt-2">
            <PDFDocument v-bind="{url, height}" />
      </div>
  </div>
</template>
<script>
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import router from '@/router/index'

export default {
  components: {
    PDFDocument
  },
  data() {
    return {
      fechaDeReporte: moment().format('YYYY-MM-DD'),
      url: '////fscivil//EQUITAS//JUZGADOS//7C//2019//ACUERDOS//3821751_5370765_FDJ_FORMA JURIS VOL .docx',
      height: '700px',
    }
  },
  methods: {
    regresarVistaAnterior: function() {
      router.push({ name: "CedulasEnviadas" });
    }
  }
};
</script>

<style scoped>
   #fecha-busqueda-informacion {
        background-color: #1e2020;
        height: 4em;
        border-radius: 9px;
    }

    .contenedor-color-negro {
        padding: 1em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/EnvioAJuzgado/Reportes/CReporteCedulasEnviadas.vue